export const getUsePassIndex = (paramsPassId, bookGroup) => {
  const passId = paramsPassId.match(/,/)
    ? paramsPassId.split(",")[0]
    : paramsPassId;

  // パスのインデックスを抽出
  let index = null;
  bookGroup.books[0].passes.forEach(function (pass, i) {
    console.log("pass :>> ", pass);
    if (pass.id == passId) {
      index = i;
    }
  });

  return index;
};
